/* eslint-disable no-else-return */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react'
import { Text, Pane, Button, Content, Flex } from '@leverege/ui-elements'
import { GlobalState, UI } from '@leverege/ui-redux'

const docURL = 'https://help.ag.recovr.biz/en/articles/11115858-coming-soon-john-deere-inventory-syncing'

function ResyncInventoryCard( props ) {
  const parentItem = props.parentItem
  const companyId = parentItem.id
  const systemId = parentItem.data.systemId
  const resyncStatusKey = `deere/company/${companyId}/resyncStatus`

  const [ isResyncing, setIsResyncing ] = useState( false )
  const [ lastSyncTime, setLastSyncTime ] = useState( null )

  const checkLastSync = async () => {
    try {
      await GlobalState.dispatch( async ( dispatch, getState, { api } ) => {
        const response = await api.interface( systemId, 'company' ).obj( companyId ).get()
        const lastSyncedAt = response?.data?.johnDeere?.lastSyncedAt
        if ( lastSyncedAt ) {
          const formattedTime = new Date( lastSyncedAt ).toLocaleString()
          setLastSyncTime( formattedTime )
          await dispatch( UI.set( resyncStatusKey, { lastSyncTime: lastSyncedAt } ) )
          setIsResyncing( false )
        }
      })
    } catch ( error ) {
      console.error( 'Error checking last sync:', error )
      setIsResyncing( false )
    }
  }

  useEffect(() => {
    checkLastSync()
  }, [])

  const onResyncClick = async () => {
    setIsResyncing( true )

    try {
      await GlobalState.dispatch( async ( dispatch, getState, { api } ) => {

        await api.interface( systemId, 'company' )
          .obj( companyId )
          .srv( 'deereAssets' )
          .post( 'syncInventory' )

        const startTime = Date.now()
        const TIMEOUT_MS = 120000
        const POLLING_INTERVAL_MS = 5000

        const checkSyncStatus = async () => {
          await checkLastSync()
          return Date.now() - startTime > TIMEOUT_MS
        }

        return new Promise( resolve => {
          const interval = setInterval( async () => {
            const isDone = await checkSyncStatus()

            if ( isDone ) {
              clearInterval( interval )
              setIsResyncing( false )
              resolve()
            }
          }, POLLING_INTERVAL_MS )
        })
      })
    } catch ( error ) {
      console.error( 'Error resyncing inventory:', error )
      setIsResyncing( false )
    }
  }

  return (
    <Pane style={{
      backgroundColor: '#F9FAFB',
      border: '1px solid #E5E7EB',
      borderRadius: '8px',
      padding: '24px',
      width: '100%',
      marginBottom: '24px'
    }}>
      <Content relative>
        <Content.Header>
          <Flex variant="row" justify="space-between" align="center" style={{ marginBottom: '16px' }}>
            <Text variant="title">
              Resync Inventory
            </Text>
            <Button
              variant="secondary"
              onClick={isResyncing ? undefined : onResyncClick}
              disabled={isResyncing}
              icon={isResyncing ? null : "fa-solid fa-rotate"}
              style={{ backgroundColor: 'white', borderRadius: '4px', padding: '8px 16px', border: '1px solid #E5E7EB' }}
            >
              {isResyncing ? (
                <Flex variant="row" align="center" gap={8}>
                  <i style={{ color: '#0066FF', fontSize: 20 }} className="fa-solid fa-spinner-scale fa-spin-pulse" />
                  <Text>Check for Updates</Text>
                </Flex>
              ) : 'Check for Updates'}
            </Button>
          </Flex>
        </Content.Header>

        <Content.Area>
          <Text style={{ color: '#394756', lineHeight: '24px' }}>
            Your equipment inventory will be synced from John Deere operations to RecovR every 24 hours. To resync your inventory now, click the button above. For more information on John Deere inventory syncing{' '}
            <a href={docURL} target='_blank' rel="noopener noreferrer" style={{ color: '#0066FF', textDecoration: 'none' }}>
              read the documentation
            </a>
            .
          </Text>
          {lastSyncTime && (
            <Text style={{ color: '#6B7280', marginTop: '16px', fontSize: '14px' }}>
              Last Synced {lastSyncTime}
            </Text>
          )}
        </Content.Area>
      </Content>
    </Pane>
  )
}

export default ResyncInventoryCard